import { EntityId, Nullable } from '@Models';
import { RequestAction, RequestDataSuccess } from '@Repository/RequestAction';
import { Result } from './type';
import { ICrudEntityAction } from '@Redux/ICrudEntityAction';

export abstract class IEntityAction<
  I extends string | number,
  T extends EntityId<I>,
  Q extends RequestDataSuccess<T>,
> extends ICrudEntityAction<T> {
  public fetchData =
    ({ entityId }: { entityId: I }): Result<void> =>
    async (dispatch) => {
      dispatch(this.areLoading(true));

      const cachedItem = await this.getCachedItem({
        entityId: entityId,
        locale: null,
      });
      if (cachedItem != null) {
        dispatch(this.cacheDataSuccess(cachedItem));
        dispatch(this.subFetchDataBefore({ entity: cachedItem }));
      }
      const response = await this.getItem({ entityId: entityId, locale: null });

      if (this.handleFailure(response, dispatch)) return;

      const success = response as Q;
      dispatch(this.fetchDataSuccess(success.payload));
      dispatch(
        this.subFetchDataAfter({
          entity: success.payload,
          cachedItem: cachedItem,
        }),
      );
      dispatch(this.areLoading(false));
    };

  protected abstract getCachedItem({
    entityId,
    locale,
  }: {
    entityId: I;
    locale: Nullable<string>;
  }): Promise<Nullable<T>>;

  protected abstract getItem({
    entityId,
    locale,
  }: {
    entityId: I;
    locale: Nullable<string>;
  }): Promise<RequestAction>;

  protected subFetchDataBefore =
    ({ entity }: { entity: T }): Result<void> =>
    (dispatch) => {};

  protected subFetchDataAfter =
    ({
      entity,
      cachedItem,
    }: {
      entity: T;
      cachedItem: Nullable<T>;
    }): Result<void> =>
    (dispatch) => {};
}
